module.exports = __webpack_public_path__ + "media/images/mobile/home/banner9 (2)-4972de30df697e50faff335bd8d00ea9.jpg";